import React from 'react'
import pick from 'lodash/pick'
import { SubmissionError } from 'redux-form'
import { useSelector, useDispatch } from 'react-redux'

import { getCurrentUser, updateCurrentUser } from '../../ducks/users'
import Header from '../Shared/Header'
import { FullScreenLoader } from '../Shared/Loading'
import Form from './Form'

export default function Settings() {
  const user = useSelector(getCurrentUser)
  const dispatch = useDispatch()

  const handleSubmit = async values => {
    console.log('---->', values)

    try {
      await dispatch(updateCurrentUser(values))
    } catch (err) {
      if (err.response && err.response.status === 400) {
        throw new SubmissionError(err.response.data.errors)
      } else {
        throw new SubmissionError({
          _error: 'An unknown error occurred',
        })
      }
    }
  }

  if (!user) {
    return <FullScreenLoader />
  }

  const initialValues = pick(user, ['email', 'name'])

  return (
    <div>
      <Header>Account Settings</Header>
      <Form onSubmit={handleSubmit} initialValues={initialValues} />
    </div>
  )
}
